/**
 * Warns when the bill usage and the uploaded reads look like they are in different units (HCF against
 * gallons). The bill's rate is charges divided by bill usage, so a bill usage in the wrong unit prices
 * every resident by the unit factor (about 748 from HCF to gallons). Nothing is converted here.
 */

// The reads' total has to be more than this many times the bill usage before the unit warning shows.
// 10 covers HCF to gallons (about 748) with room to spare.
export const UNIT_MISMATCH_RATIO = 10;

/**
 * The distinct units the rows use, in the order first seen. Units are trimmed and compared ignoring case,
 * so "G" and "g" are one unit and the first spelling seen is the one kept. Blank units are ignored.
 * Synonyms (G, Gal, gallons) are not matched, so they count as separate units.
 */
export const findReadsUnits = rows => {
  const units = new Map();
  rows.forEach(row => {
    var _row$unitsOfMeasure;
    const unit = String((_row$unitsOfMeasure = row.unitsOfMeasure) !== null && _row$unitsOfMeasure !== void 0 ? _row$unitsOfMeasure : '').trim();
    if (unit !== '' && !units.has(unit.toLowerCase())) units.set(unit.toLowerCase(), unit);
  });
  return [...units.values()];
};

// Both arguments are in the screen's scaled integer usage units. Only reads far above the bill usage warn
// (bill entered in HCF, reads in gallons). A bill usage above the reads can be right when the meters cover
// only part of the bill, so that direction is not checked. Exactly the ratio does not warn.
export const isBillUsageUnitMismatch = (billUsageUnits, meteredUnits) => billUsageUnits > 0 && meteredUnits > billUsageUnits * UNIT_MISMATCH_RATIO;